<template>
    <div class="mini-loader-wrapper">
        <div class="mini-loader">
            <div class="corners">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="box">
                <p>P</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "MiniLoader"
};
</script>

<style scoped>
.mini-loader-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
}

.mini-loader {
  position: relative;
  width: 24px;
  height: 24px;
  animation: scaling 2.5s ease infinite;
}

.mini-loader .corners {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  animation: loading 2.5s ease infinite;
}

.mini-loader .corners span {
  position: absolute;
  width: 8px;
  height: 8px;
}

.mini-loader .corners span:nth-child(1) {
  top: 0px;
  left: 0px;
  border-top: 2px solid #78b843;
  border-left: 2px solid #78b843;
}

.mini-loader .corners span:nth-child(2) {
  top: 0px;
  right: 0px;
  border-top: 2px solid #78b843;
  border-right: 2px solid #78b843;
}

.mini-loader .corners span:nth-child(3) {
  bottom: 0px;
  right: 0px;
  border-bottom: 2px solid #78b843;
  border-right: 2px solid #78b843;
}

.mini-loader .corners span:nth-child(4) {
  bottom: 0px;
  left: 0px;
  border-bottom: 2px solid #78b843;
  border-left: 2px solid #78b843;
}

.mini-loader .box {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mini-loader .box p {
  margin: 0;
  color: #78b843;
  font-size: 16px;
  font-family: arial;
  font-weight: bold;
  position: absolute;
  top: -17%;
  left: 25%;
}

@keyframes loading {
  50% {
    transform: rotate(135deg);
  }
  100% {
    transform: rotate(270deg);
  }
}

@keyframes scaling {
  0% {
    transform: scale(1.0);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1.0);
  }
}
</style>

